import { render, staticRenderFns } from "./TeamInvitations.vue?vue&type=template&id=73c2e8c6"
import script from "./TeamInvitations.vue?vue&type=script&lang=js"
export * from "./TeamInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports